/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Button,
  Flex,
  FormControl,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Text,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import parser from 'html-react-parser';
import { nanoid } from 'nanoid';
import { TbChevronDown, TbChevronUp } from 'react-icons/tb';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';
import FlowerDivider from '@components/Layout/FlowerDivider';
import SingleLineText from '@components/Text/SinglelineText';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';

/* Services */
import { fetchCategoryCards } from '../../services/yogaService';

/**
 *
 * @param {object} section
 * @returns SadhanaDetailList
 */
const SadhanaDetailList = ({ section, region, lang }) => {
  const [prgUrl, setPrgUrl] = useState('');
  const [eventIds, setEventId] = useState(null);
  const [events, setEvents] = useState(undefined);
  const defaultEvents = [
    {
      id: 4118,
      name: 'Bhoomi',
      seats_available: 99999,
      start_date: false,
      end_date: false,
      price: 7500,
      currency: 'INR',
      person_count: 1,
      is_expired: false,
      description:
        '<ul><li>Shared dorm stay (consecrated Adiyogi Alayam)</li><li>Guided sadhana</li><li>Teerthakund dip</li><li>Special Marghazi sadhana</li></ul>',
    },
    {
      id: 4118,
      name: 'Agni',
      seats_available: 99999,
      start_date: false,
      end_date: false,
      price: 7500,
      currency: 'INR',
      person_count: 1,
      is_expired: false,
      description:
        '<ul><li>Non-AC Twin sharing accommodation</li><li>Bhasktrika</li><li>15-Min Walk from Program Area</li></ul>',
    },
    {
      id: 4118,
      name: 'Jala',
      seats_available: 99999,
      start_date: false,
      end_date: false,
      price: 15000.0,
      currency: 'INR',
      person_count: 1,
      is_expired: false,
      description:
        '<ul><li>Non-AC Twin sharing accommodation</li><li>Bhasktrika</li><li>Shankmukhi Kriya</li><li>5-Min Walk from Program Area</li></ul>',
    },
  ];
  const [activeCardId, setActiveCardId] = useState(null);
  const [isSelect, setIsSelect] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const sectionContent = section?.sectionContent;
  // console.log('events', events, selectedOption);

  const handleRadioClick = (event, value, status, data) => {
    // console.log(data);
    event.preventDefault();
    // console.log();
    if (status !== 'Full') {
      setEventId(data.eventIds);
    }
  };

  const handleCardClick = (event, ticket, data) => {
    // console.log(ticket);
    event.preventDefault();
    setActiveCardId(ticket.id);
    setPrgUrl(
      `${config.MARGAZHI_SADHANA_REG_URL}${data.id}&ticket=${ticket.name
        .split(' ')
        .join('-')}`
    );
  };

  const cardStyle = {
    Open: {
      boxShadow: '0 0 2px #979797',
      background: '#FFFFFF',
    },
    Selected: {
      boxShadow:
        '0px 0px 0px 2px #be3a1d,3.06087px 18.7518px 41px rgba(34, 30, 2, 0.08), 1.98389px 12.154px 24.0116px rgba(34, 30, 2, 0.0607407), 1.179px 7.22293px 13.0593px rgba(34, 30, 2, 0.0485926), 0.612173px 3.75037px 6.6625px rgba(34, 30, 2, 0.04), 0.249404px 1.52793px 3.34074px rgba(34, 30, 2, 0.0314074), 0.0566827px 0.347256px 1.61343px rgba(34, 30, 2, 0.0192593)',
      background: '#FFFCE1',
    },
    Full: {
      outline: 'none',
      boxShadow: 'none',
      background: '#F5F0E5',
    },
  };

  // Helper function to format the date
  const formatDate = dateString => {
    const date = new Date(dateString);
    const options = {
      day: '2-digit',
      month: 'short',
    };

    // Get the parts of the date
    const { day, month } = new Intl.DateTimeFormat('en-GB', options)
      .formatToParts(date)
      .reduce(
        (acc, part) => {
          if (part.type in acc) {
            acc[part.type] = part.value;
          }
          return acc;
        },
        { day: '', month: '' }
      );

    // Format with commas
    return `${day} ${month}`;
  };

  const eventHandler = async () => {
    const response = await fetchCategoryCards(eventIds.split(','));
    // console.log(response, 'response');
    const { result } = response;
    let data = [];
    if (result) {
      result?.map(card => {
        // console.log(card, 'card');
        const startDate = formatDate(card.start_date);
        const endDate = formatDate(card.end_date);
        card.start = startDate;
        card.end = endDate;
        data.push(card);
      });
      // setSelectedOption(null);
    }

    const groupedData = Object.groupBy(
      data,
      ({ start, end }) => start + ' - ' + end
    );
    setEvents(groupedData);
    setPrgUrl('');
  };

  useEffect(() => {
    if (eventIds) {
      eventHandler();
    }
  }, [eventIds]);

  useEffect(() => {
    if (events) {
      if (events && Object.keys(events)?.length === 1) {
        // console.log(typeof Object.keys(events)[0]);
        setSelectedOption(Object.keys(events)[0]);
        // console.log(selectedOption, '===>');
      } else {
        setSelectedOption(null);
      }
    }
  }, [events]);

  return (
    <Box
      id={section.sectionId}
      mt={{ base: '20px', md: '30px' }}
      maxW={680}
      mx="auto"
      width="100%"
      px={{ base: '0', md: '20px' }}
    >
      <Flex justifyContent="center" alignItems="center">
        <Box
          as="h2"
          fontFamily="'FedraSansStd-A-medium', 'sans-serif'"
          fontSize="27px"
          lineHeight="1.13"
          color="#02026c"
          textAlign="center"
        >
          {sectionContent[0].titleText}
          <FlowerDivider p={`10px 0 10px 0`} transfrm={'rotate(0deg)'} />
        </Box>
      </Flex>
      <MidContainer w={'768'}>
        <StructuredTextParser
          str={render(sectionContent[1]?.body)}
          region={region}
          lang={lang}
          m={{ base: '0 auto 20px', md: '0 auto 35px' }}
          p="0 20px"
          className="programDetailsText"
          fontFamily="FedraSansStd-book"
          fontSize="16px"
        />
        {/* {eventIds} */}
      </MidContainer>
      <Flex flexDir="column" bg="#FCFAF6">
        <SingleLineText
          fontFamily="'FedraSansStd-A-medium', 'sans-serif'"
          sectionContent={sectionContent[3]}
          color="#02026C"
          mt={{ base: '30px', md: '40px' }}
          mb={{ base: '8px', md: '0px' }}
          fontSize="20px"
        />
        <Box>
          <Grid align="start" justify="center">
            <FormControl>
              <RadioGroup
                onChange={event => {
                  setEventId(event.target.value);
                }}
                value={eventIds}
              >
                <Flex
                  p={4}
                  placeContent={{ base: 'left', md: 'left' }}
                  gridRowGap={{ base: '15px', md: '30px' }}
                  flexWrap="wrap"
                  alignItems={{ base: 'flex-start', md: 'flex-start' }}
                  w="100%"
                  maxW={{ base: '310px', sm: '340px', md: 520 }}
                  mx="auto"
                  gap="15px"
                  justifyContent={{ base: '', md: 'flex-start' }}
                >
                  {sectionContent[4]?.data?.map((data, i) => {
                    if (data.Status === 'Full') {
                      return null;
                    }
                    return (
                      <Box
                        display="grid"
                        position="relative"
                        backgroundColor="white"
                        w={{ base: '47%', sm: '146px', md: '152px' }}
                        maxW={{ base: '146px', md: '152px' }}
                        maxH={58}
                        as="label"
                        key={nanoid(4)}
                        p="20px 14px"
                        borderRadius="6px"
                        borderStyle="solid"
                        borderColor="#979797"
                        borderWidth="0.60px"
                        style={
                          eventIds?.indexOf(data.eventIds) > -1
                            ? cardStyle.Selected
                            : data.Status === 'Full'
                            ? cardStyle.Full
                            : cardStyle.Open
                        }
                        onClick={event =>
                          handleRadioClick(
                            event,
                            data.LinkUrl,
                            data.Status,
                            data
                          )
                        }
                        cursor={data.Status === 'Full' ? 'cursor' : 'pointer'}
                        _hover={{
                          outline:
                            data.Status !== 'Full' &&
                            '1px solid #CF4520 !Important',
                          boxShadow:
                            data.Status !== 'Full' &&
                            '0 0 0px 2px #CF4520, 3.06087px 18.7518px 41px rgba(34, 30, 2, 0.08), 1.98389px 12.154px 24.0116px rgba(34, 30, 2, 0.0607407), 1.179px 7.22293px 13.0593px rgba(34, 30, 2, 0.0485926), 0.612173px 3.75037px 6.6625px rgba(34, 30, 2, 0.04), 0.249404px 1.52793px 3.34074px rgba(34, 30, 2, 0.0314074), 0.0566827px 0.347256px 1.61343px rgba(34, 30, 2, 0.0192593) !Important',
                          background:
                            data.Status !== 'Full' && '#FFFCE1 !Important',
                        }}
                      >
                        {data.Status === 'Full' && (
                          <Box
                            pos="absolute"
                            top={0}
                            right={0}
                            left={0}
                            bottom={0}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            textAlign="center"
                            background="#494949"
                            opacity="0.7"
                            borderRadius="6px"
                            width="100%"
                            height="100%"
                          >
                            <Text
                              color="#fff"
                              fontSize="24px"
                              fontFamily="FedraSansStd-medium"
                            >
                              FULL
                            </Text>
                          </Box>
                        )}
                        <Flex justifyContent="space-between" w="100%" pr="5px">
                          <Box
                            fontFamily="FedraSansStd-medium"
                            fontStyle="normal"
                            fontSize="18px"
                            ml=""
                            lineHeight="9.62px"
                            wordWrap="break-word"
                            display="flex"
                            alignItems="center"
                            fontFeatureSettings="case"
                            color="#28231E"
                          >
                            {data.Name}
                          </Box>
                          <Radio
                            name="Tab2"
                            id="radio2"
                            className="radio"
                            colorScheme="orange"
                            key={data.Name}
                            value={data.eventIds}
                            boxShadow="0 0 0 1px #CF4520"
                            w={{ base: '8px', md: '11px' }}
                            cursor={
                              data.Status === 'Full' ? 'cursor' : 'pointer'
                            }
                            isDisabled={data.Status === 'Full' ? true : false}
                          />
                        </Flex>
                        {/* <Box
                            w={{ base: '80px', md: '80px' }}
                            fontFamily="FedraSansStd-book"
                            background="#E4DED4"
                            borderRadius="4px"
                            fontSize={{ base: '12px', md: '14px' }}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            color="#000"
                            m={{ base: '7px 0 2px 0', md: '13px 0 8px 0' }}
                          >
                            {data.NormalPrice}
                          </Box>
                          <Box
                            mt={{ base: '0', md: '0px' }}
                            fontFamily="FedraSansStd-book"
                            fontSize={{ base: '14px', md: '16px' }}
                          >
                            {data.Descripton.value_1}
                          </Box> */}
                      </Box>
                    );
                  })}
                </Flex>
              </RadioGroup>
            </FormControl>
          </Grid>
        </Box>
        <Box w="auto">
          <SingleLineText
            fontFamily="'FedraSansStd-A-medium', 'sans-serif'"
            sectionContent={sectionContent[5]}
            textAlign="center"
            color="#02026C"
            mb="15px"
            fontSize="20px"
          />
          {/* {selectedOption} */}
          <Button
            flex="1"
            bg="#ffffff"
            value={selectedOption}
            border="1px solid #B7987E"
            color="#B7987E"
            w={185}
            h="54px"
            rounded="md"
            fontWeight={350}
            mx="auto"
            display="inline-flex"
            justifyContent="space-between"
            _hover={{ border: '1px solid #B7987E' }}
            _focus={{ border: '1px solid #B7987E' }}
            _active={{ border: '1px solid #B7987E' }}
            rightIcon={
              isSelect ? (
                <TbChevronUp />
              ) : typeof events !== 'undefined' &&
                Object.keys(events).length > 1 ? (
                <TbChevronDown />
              ) : (
                ''
              )
            }
            onClick={() => setIsSelect(!isSelect)}
            onBlur={() => setIsSelect(false)}
            className="selectButton"
            textTransform="capitalize"
            fontFamily="FedraSerifAStdBook"
          >
            <Text
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              // color="#A33A2C"
            >
              {selectedOption ? selectedOption : sectionContent[6].text}
            </Text>
            {eventIds && events && isSelect && (
              <Flex
                _before={{ content: "''", height: '17px' }}
                _after={{ content: "''", height: '17px' }}
                display={isSelect ? 'block' : 'none'}
                _hover={{ display: 'block' }}
                className="options"
                alignItems="flex-start"
                alignContent="flex-start"
                onClick={() => setIsSelect(false)}
                position="absolute"
                top={{ base: '45px', md: '47px' }}
                border="1px solid #EDD1C2"
                zIndex="100"
                left="0"
                minW={{ base: '185px', md: '185px' }}
                flexDir="column"
                bg="#ffffff"
                mt={{ base: '0', md: '8px' }}
                w="auto"
                p="17px"
              >
                {eventIds &&
                  events &&
                  Object.keys(events)?.map((eve, i) => {
                    if (eve?.length <= 2) {
                      return (
                        <Box padding="8px 0px" cursor="pointer">
                          <Text
                            color="#B7987E"
                            fontFamily="FedraSansStd-book"
                            textAlign="left"
                            _hover={{ color: '#A33A2C', fontWeight: '400' }}
                          >
                            {sectionContent[6].text}
                          </Text>
                        </Box>
                      );
                    }
                    return (
                      <Box
                        padding="8px 0px"
                        cursor="pointer"
                        key={nanoid()}
                        // selected={cat.urlAlias === router.query.category}
                        value={eve}
                      >
                        <Text
                          color="#B7987E"
                          fontFamily="FedraSansStd-book"
                          textAlign="left"
                          _hover={{ color: '#A33A2C', fontWeight: '400' }}
                          // onMouseEnter={() => setIsCategory(cat.title)}
                          onClick={() => {
                            setSelectedOption(eve);
                          }}
                        >
                          {eve}
                        </Text>
                      </Box>
                    );
                  })}
              </Flex>
            )}
          </Button>
          {/* {events && selectedOption && ( */}
          <SingleLineText
            fontFamily="'FedraSansStd-A-medium', 'sans-serif'"
            sectionContent={sectionContent[7]}
            color="#02026C"
            fontSize="20px"
            mb="15px"
          />
          {/* )} */}
          <Box>
            <Grid align="start" justify="center">
              <FormControl>
                <RadioGroup
                  value={activeCardId}
                  onChange={event => setActiveCardId(event.target.value)}
                >
                  <Flex
                    p="4"
                    placeContent={{ base: 'center', md: 'left' }}
                    alignItems={{ base: 'center', md: 'left' }}
                    flexWrap="wrap"
                    flexDirection={{ base: 'column', md: 'row' }}
                    w="100%"
                    justifyContent="space-between"
                    maxW="610px"
                    mx="auto"
                    pos="relative"
                    _before={{
                      content: "''",
                      display: selectedOption ? 'none' : 'block',
                      pos: 'absolute',
                      width: '100%',
                      height: '100%',
                      top: '0',
                      left: '0',
                      bottom: '0',
                      right: 0,
                      bg: 'rgba(252, 250, 246, 0.81)',
                      backdropFilter: 'blur(2px)',
                      zIndex: 10,
                    }}
                  >
                    {!selectedOption &&
                      defaultEvents?.map((ticket, i) => {
                        if (ticket.name) {
                          return (
                            <Box
                              display="grid"
                              position="relative"
                              backgroundColor="white"
                              w={280}
                              minH={300}
                              h="auto"
                              as="label"
                              key={nanoid(4)}
                              p="30px 21px"
                              borderRadius="6px"
                              mb="30px"
                              borderStyle="solid"
                              borderColor="#979797"
                              borderWidth="0.60px"
                              style={
                                activeCardId === ticket.id
                                  ? cardStyle.Selected
                                  : ticket.is_expired
                                  ? cardStyle.Full
                                  : cardStyle.Open
                              }
                              onClick={event => handleCardClick(event, ticket)}
                              cursor={ticket.is_expired ? 'cursor' : 'pointer'}
                              _hover={{
                                outline:
                                  !ticket.is_expired &&
                                  '1px solid #CF4520 !Important',
                                boxShadow:
                                  !ticket.is_expired &&
                                  '0 0 0px 2px #CF4520, 3.06087px 18.7518px 41px rgba(34, 30, 2, 0.08), 1.98389px 12.154px 24.0116px rgba(34, 30, 2, 0.0607407), 1.179px 7.22293px 13.0593px rgba(34, 30, 2, 0.0485926), 0.612173px 3.75037px 6.6625px rgba(34, 30, 2, 0.04), 0.249404px 1.52793px 3.34074px rgba(34, 30, 2, 0.0314074), 0.0566827px 0.347256px 1.61343px rgba(34, 30, 2, 0.0192593) !Important',
                                background:
                                  !ticket.is_expired && '#FFFCE1 !Important',
                              }}
                            >
                              <Flex
                                justifyContent="space-between"
                                height="fit-content"
                              >
                                <Box
                                  fontFamily="FedraSansStd-book"
                                  fontStyle="normal"
                                  fontWeight="600"
                                  fontSize="20px"
                                  lineHeight="9.62px"
                                  wordWrap="break-word"
                                  display="flex"
                                  alignItems="center"
                                  fontFeatureSettings="case"
                                  color="#000"
                                >
                                  {ticket.name}
                                </Box>
                                <Radio
                                  name="Tab2"
                                  id="radio2"
                                  className="radio"
                                  colorScheme="orange"
                                  key={ticket.id}
                                  value={ticket.id}
                                  boxShadow="0 0 0 1px #CF4520"
                                  width="26px"
                                  // cursor={
                                  //   data.Status === 'Full'
                                  //     ? 'cursor'
                                  //     : 'pointer'
                                  // }
                                  // isDisabled={
                                  //   data.Status === 'Full' ? true : false
                                  // }
                                />
                              </Flex>
                              <Box
                                w="100%"
                                fontFamily="FedraSansStd-medium"
                                background="#E4DED4"
                                borderRadius="4px"
                                fontSize="16px"
                                color="#28231E"
                                p="5px"
                                my="20px"
                                height="max-content"
                              >
                                {ticket.currency}{' '}
                                {new Intl.NumberFormat('en').format(
                                  ticket?.price
                                )}
                              </Box>
                              <Box
                                mt={{ base: '0', md: '0px' }}
                                fontFamily="FedraSansStd-book"
                                fontSize="16px"
                                pl="20px"
                              >
                                {parser(ticket?.description || '')}
                              </Box>
                            </Box>
                          );
                        } else null;
                      })}
                    {events &&
                      selectedOption &&
                      events[selectedOption]?.map((data, i) => {
                        return (
                          <>
                            {data.tickets.map(ticket => (
                              <Box
                                display="grid"
                                position="relative"
                                backgroundColor="white"
                                w={280}
                                minH={300}
                                h="auto"
                                as="label"
                                key={nanoid(4)}
                                p="30px 21px"
                                borderRadius="6px"
                                mb="30px"
                                borderStyle="solid"
                                borderColor="#979797"
                                borderWidth="0.60px"
                                style={
                                  activeCardId === ticket.id
                                    ? cardStyle.Selected
                                    : ticket.is_expired
                                    ? cardStyle.Full
                                    : cardStyle.Open
                                }
                                onClick={event =>
                                  handleCardClick(event, ticket, data)
                                }
                                cursor={
                                  ticket.is_expired ? 'cursor' : 'pointer'
                                }
                                _hover={{
                                  outline:
                                    !ticket.is_expired &&
                                    '1px solid #CF4520 !Important',
                                  boxShadow:
                                    !ticket.is_expired &&
                                    '0 0 0px 2px #CF4520, 3.06087px 18.7518px 41px rgba(34, 30, 2, 0.08), 1.98389px 12.154px 24.0116px rgba(34, 30, 2, 0.0607407), 1.179px 7.22293px 13.0593px rgba(34, 30, 2, 0.0485926), 0.612173px 3.75037px 6.6625px rgba(34, 30, 2, 0.04), 0.249404px 1.52793px 3.34074px rgba(34, 30, 2, 0.0314074), 0.0566827px 0.347256px 1.61343px rgba(34, 30, 2, 0.0192593) !Important',
                                  background:
                                    !ticket.is_expired && '#FFFCE1 !Important',
                                }}
                              >
                                {ticket?.is_expired && (
                                  <Box
                                    pos="absolute"
                                    top={0}
                                    right={0}
                                    left={0}
                                    bottom={0}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    textAlign="center"
                                    background="#494949"
                                    opacity="0.7"
                                    borderRadius="6px"
                                    width="100%"
                                    height="100%"
                                  >
                                    <Text
                                      color="#fff"
                                      fontSize="24px"
                                      fontFamily="FedraSansStd-medium"
                                    >
                                      FULL
                                    </Text>
                                  </Box>
                                )}
                                <Flex
                                  justifyContent="space-between"
                                  height="fit-content"
                                >
                                  <Box
                                    fontFamily="FedraSansStd-book"
                                    fontStyle="normal"
                                    fontWeight="600"
                                    fontSize="20px"
                                    lineHeight="9.62px"
                                    wordWrap="break-word"
                                    display="flex"
                                    alignItems="center"
                                    fontFeatureSettings="case"
                                    color="#000"
                                  >
                                    {ticket.name}
                                  </Box>
                                  <Radio
                                    name="Tab2"
                                    id="radio2"
                                    className="radio"
                                    colorScheme="orange"
                                    key={ticket.id}
                                    value={ticket.id}
                                    boxShadow="0 0 0 1px #CF4520"
                                    width="26px"
                                    h="26px"
                                    // cursor={
                                    //   data.Status === 'Full'
                                    //     ? 'cursor'
                                    //     : 'pointer'
                                    // }
                                    // isDisabled={
                                    //   data.Status === 'Full' ? true : false
                                    // }
                                  />
                                </Flex>
                                <Box
                                  w="100%"
                                  fontFamily="FedraSansStd-medium"
                                  background="#E4DED4"
                                  borderRadius="4px"
                                  fontSize="16px"
                                  color="#28231E"
                                  p="5px"
                                  my="20px"
                                  height="max-content"
                                >
                                  {ticket.currency}{' '}
                                  {new Intl.NumberFormat('en').format(
                                    ticket?.price
                                  )}
                                </Box>
                                <Box
                                  mt={{ base: '0', md: '0px' }}
                                  fontFamily="FedraSansStd-book"
                                  fontSize="16px"
                                  pl="20px"
                                >
                                  {parser(ticket?.description || '')}
                                </Box>
                              </Box>
                            ))}
                          </>
                        );
                      })}
                  </Flex>
                </RadioGroup>
              </FormControl>
            </Grid>
          </Box>
        </Box>
      </Flex>
      <Flex
        maxW={660}
        px="20px"
        mx="auto"
        w="100%"
        justifyContent="center"
        alignContent="center"
        flexDir="column"
      >
        <StructuredTextParser
          fontFamily="FedraSansStd-book"
          fontSize="16px"
          color="#000"
          maxW="600px"
          mt="2rem"
          str={render(sectionContent[9].body)}
        />
        {/* {events && selectedOption && ( */}
        <Box display="flex" placeContent="center" mt="50px" mb="50px">
          <Link
            href={refineUrlDomain(prgUrl)}
            mb="30px"
            display="block"
            fontWeight={'500'}
            fontFamily={'FedraSansStd-medium'}
            fontSize={'18px'}
            bgColor={prgUrl ? '#cf4520' : '#A4A4A4'}
            minH="50px"
            textAlign="left"
            padding={'14px 29px'}
            borderRadius="5px"
            color="#faf7f0"
            textDecoration="none"
            width={'auto'}
            cursor={prgUrl ? 'pointer' : 'not-allowed'}
            _hover={{
              bg: prgUrl ? '#000054' : '',
            }}
            target={prgUrl ? '_blank' : ''}
          >
            {sectionContent[8]?.buttonText}
          </Link>
        </Box>
        {/* )} */}
      </Flex>
      <style>
        {`
            .radio{
                border:0 !important;
                background:transparent !important;
            }
            .radio:before{
                background:#CF4520 !important;
            }
            .radio[data-disabled]:before  {
                background:none !important;
            }
            .programDetailsText p {
                padding: 10px 0;
            }
            .programdetail_content {
                font-family: 'FedraSansStd-book';
                margin-top: 0 !important;
                padding-top: 15px;
            }
            .programdetail_content ul {
                margin-left: 28px;
            }
            @media (max-width: 768px) {
                .programdetail_content {
                    padding: 15px 10px; 
                }
                .programdetail_content ul {
                    margin-left: 20px;
                }
            }
            `}
      </style>
    </Box>
  );
};

export default SadhanaDetailList;
